export default __webpack_public_path__ + "d447f6bda7dcd9ea948b3cd30595d9a6.jpg";